import React, { useEffect } from "react";
import FirebaseAnalytics from "../services/analytics.service";
import BillPaymentForm from "../views/bill-payment/bill-payment-index";

export default function BillPaymentUI(props) {
	
	useEffect(() => {
		FirebaseAnalytics.generic_event(12);
	}, [])

	return (
		<div>
            <BillPaymentForm props={props}/>
		</div>
	)
}